const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  border-radius: var(--goto-spacing-01);
  margin: 0;
  padding: 8px 0;
  width: 100%;
  list-style: none;
  display: inline-flex;
  flex-direction: column;
  word-break: break-word;
  background-color: var(--goto-menu-background);
}

:host([slot=submenu]) {
  margin-top: -8px;
}`; export default styles;